'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.default = pluralize;

/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function pluralize(word, count) {
  return `${count} ${word}${count === 1 ? '' : 's'}`;
}
